import { makeStyles } from '@fluentui/react-components';

export interface ParcelStatusCell {
  key: string;
  label: string;
  color: string;
}

export interface ParcelStatusLegendItem {
  label: string;
  color: string;
}

interface Props {
  cells: ParcelStatusCell[];
  legend?: ParcelStatusLegendItem[];
  columns?: number;
  cellHeight?: number;
  onCellClick?: (cell: ParcelStatusCell) => void;
}

const useStyles = makeStyles({
  grid: { display: 'grid', gap: '4px', borderRadius: '10px', overflow: 'hidden' },
  cell: { display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '11px', fontWeight: 700 },
  legend: { display: 'flex', gap: '14px', marginTop: '12px', fontSize: '11.5px', flexWrap: 'wrap' },
  legendItem: { display: 'flex', alignItems: 'center', gap: '4px' },
  swatch: { display: 'inline-block', width: '8px', height: '8px', borderRadius: '2px' },
});

/** Grid de celdas coloreadas por estado — ej. mapa de módulos/parcelas por status. */
export function ParcelStatusGrid({ cells, legend, columns = 4, cellHeight = 64, onCellClick }: Props) {
  const s = useStyles();
  return (
    <div>
      <div className={s.grid} style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
        {cells.map(c => (
          <div
            key={c.key}
            className={s.cell}
            style={{ background: c.color, height: cellHeight, cursor: onCellClick ? 'pointer' : undefined }}
            onClick={onCellClick ? () => onCellClick(c) : undefined}
          >
            {c.label}
          </div>
        ))}
      </div>
      {legend && (
        <div className={s.legend}>
          {legend.map(l => (
            <span key={l.label} className={s.legendItem}>
              <span className={s.swatch} style={{ background: l.color }} />
              {l.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
